import axios from 'axios';

export default class AuthService {
    doSign(user) {
        return axios.post(`/api/auth/login`, user);
    }

    doSignFacebook(accessToken) {
        const data = {
            "facebook": {
                "token": accessToken
            }
        };

        return axios.post(`/api/auth/facebook`, data);
    }

    doSignOut() {
        const token = localStorage.token;
        return axios.get(`/api/auth/logout?token=${token}`);
    }

    doRegister(params) {
        return axios.post(`/api/auth/register`, params);
    }

    doSaveToken(token) {
        localStorage.token = token;
    }

    doResetPassword(params) {
        const data = {
            "password": params.password,
            "password_confirmation": params.password_confirmation,
            "token": params.token
        };

        return axios.post(`/api/reset/password`, data);
    }

    isSigned() {
        return localStorage.token;
    }

    deleteCredentials() {
        localStorage.removeItem('token');
        localStorage.removeItem('accessToken');
    }

    getRefreshToken() {
        return axios.get(`/api/auth/refresh-token?token=${localStorage.token}`);
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/auth-service.js